import { lazy } from 'react'
import AclGuard from '@/@core/guard/AclGuard'

const ManageUserPage = lazy(() => import('./clusters/md-user/pages/user/components/ManageUserPage'))
const ManageUserAddPage = lazy(() => import('./clusters/md-user/pages/user/components/ManageUserAddPage'))
const ManageUserDetailPage = lazy(() => import('./clusters/md-user/pages/user/components/ManageUserDetailPage'))

const WorkflowListPage = lazy(() => import('./clusters/workflow-manager/pages/workflow-manager/features/workflow-list'))
const EditWorkflowPage = lazy(() => import('./clusters/workflow-manager/pages/workflow-manager/features/edit-workflow'))
const CreateActorPage = lazy(() => import('./clusters/workflow-manager/pages/workflow-manager/features/create-actor'))
const EditActorPage = lazy(() => import('./clusters/workflow-manager/pages/workflow-manager/features/edit-actor'))

const WorkflowStudioListPage = lazy(
  () => import('./clusters/workflow-studio/pages/workflow-studio/features/workflow-studio-list')
)
const EditWorkflowStudioPage = lazy(
  () => import('./clusters/workflow-studio/pages/workflow-studio/features/edit-workflow-studio')
)
const CreateActorStudioPage = lazy(
  () => import('./clusters/workflow-studio/pages/workflow-studio/features/actor/create-actor')
)
const EditActorStudioPage = lazy(
  () => import('./clusters/workflow-studio/pages/workflow-studio/features/actor/edit-actor')
)

const WorkflowStudioTicketSimulationListPage = lazy(
  () => import('./clusters/workflow-simulation/pages/ticket-simulation/features/ticket-list/PageTicketSimulationList')
)
const WorkflowStudioTicketSimulationDetailPage = lazy(
  () =>
    import('./clusters/workflow-simulation/pages/ticket-simulation/features/ticket-detail/PageTicketSimulationDetail')
)
const PageTicketSimulationCreateUpdate = lazy(
  () =>
    import(
      './clusters/workflow-simulation/pages/ticket-simulation/features/ticket-create-update/PageTicketSimulationCreateUpdate'
    )
)

const WorkflowStudioWorkOrderSimulationListPage = lazy(
  () =>
    import(
      './clusters/workflow-simulation/pages/workorder-simulation/features/workorder-list/PageWorkOrderSimulationList'
    )
)

const WorkflowStudioWorkOrderSimulationCreateEditPage = lazy(
  () =>
    import(
      './clusters/workflow-simulation/pages/workorder-simulation/features/workorder-create-update/PageWorkOrderSimulationCreateEdit'
    )
)

const WorkflowStudioWorkOrderSimulationDetailPage = lazy(
  () =>
    import(
      './clusters/workflow-simulation/pages/workorder-simulation/features/workorder-detail/PageWorkOrderSimulationDetail'
    )
)

const WorkflowStudioIssueSimulationListPage = lazy(
  () => import('./clusters/workflow-simulation/pages/issue-simulation/features/issue-list/PageIssueSimulationList')
)
const WorkflowStudioIssueSimulationDetailPage = lazy(
  () => import('./clusters/workflow-simulation/pages/issue-simulation/features/issue-detail/PageIssueSimulationDetail')
)

const FormBuilderManagerListPage = lazy(
  () => import('./clusters/form-builder-manager/pages/manager/features/list-form-builder/index')
)

const FormBuilderManagerConfigurationPage = lazy(
  () => import('./clusters/form-builder-manager/pages/manager/features/configuration/index')
)

const FormBuilderManagerSimulationUserPage = lazy(
  () => import('./clusters/form-builder-simulation/pages/simple-user/features/detail/PageDetailUser')
)

const PageAlarmLog = lazy(() => import('./clusters/alarm/pages/alarm-log/components/PageAlarm'))
const PageAddCompany = lazy(() =>
  import('./clusters/company/pages/company/components/PageAddCompany').then(m => ({ default: m.PageAddCompany }))
)
const PageCompany = lazy(() =>
  import('./clusters/company/pages/company/components/PageCompany').then(m => ({ default: m.PageCompany }))
)
const PageDetailComponent = lazy(() =>
  import('./clusters/bill-of-material/pages/md-component/components/PageDetailComponent').then(m => ({
    default: m.PageDetailComponent
  }))
)
const PageAddComponent = lazy(() =>
  import('./clusters/bill-of-material/pages/md-component/components/PageAddComponent').then(m => ({
    default: m.PageAddComponent
  }))
)
const PageComponent = lazy(() =>
  import('./clusters/bill-of-material/pages/md-component/components/PageComponent').then(m => ({
    default: m.PageComponent
  }))
)
const PageComponentLevelling = lazy(() =>
  import('./clusters/bill-of-material/pages/component-levelling/components/PageComponentLevelling').then(m => ({
    default: m.PageComponentLevelling
  }))
)
const PageDetailCompressor = lazy(() =>
  import('./clusters/compressor/pages/compressor/components/PageDetailCompressor').then(m => ({
    default: m.PageDetailCompressor
  }))
)
const PageCompressor = lazy(() =>
  import('./clusters/compressor/pages/compressor/components/PageCompressor').then(m => ({ default: m.PageCompressor }))
)
const PageDetailParameterCBM = lazy(() =>
  import(
    './clusters/condition-based-monitoring/pages/condition-based-monitoring/components/PageDetailParameterCBM'
  ).then(m => ({ default: m.PageDetailParameterCBM }))
)
const PageConditionBasedMonitoring = lazy(() =>
  import(
    './clusters/condition-based-monitoring/pages/condition-based-monitoring/components/PageConditionBasedMonitoring'
  ).then(m => ({ default: m.PageConditionBasedMonitoring }))
)
const PageDashboardInsight = lazy(() => import('./clusters/md-dashboard/pages/manager/features/insight'))
const PageDashboardConfiguration = lazy(() =>
  import('./clusters/md-dashboard/pages/configuration/components/PageDashboardConfiguration').then(m => ({
    default: m.PageDashboardConfiguration
  }))
)
const PageDashboardConfig = lazy(() => import('./clusters/md-dashboard/pages/manager/features/configuration'))
const PageListtDasboard = lazy(() => import('./clusters/md-dashboard/pages/manager/features/list-dasboard'))
const PageAddDefect = lazy(() =>
  import('./clusters/md-defect/pages/defect/components/PageAddDefect').then(m => ({ default: m.PageAddDefect }))
)
const PageDefect = lazy(() =>
  import('./clusters/md-defect/pages/defect/components/PageDefect').then(m => ({ default: m.PageDefect }))
)
const ManageDepartmentEditPage = lazy(
  () => import('./clusters/manage-departement/pages/department/components/ManageDepartmentEditPage')
)
const ManageDepartmentDetailPage = lazy(
  () => import('./clusters/manage-departement/pages/department/components/ManageDepartmentDetailPage')
)
const ManageDepartmentAddPage = lazy(
  () => import('./clusters/manage-departement/pages/department/components/ManageDepartmentAddPage')
)
const ManageDepartmentPage = lazy(
  () => import('./clusters/manage-departement/pages/department/components/ManageDepartmentPage')
)
const PageDowntimeQueue = lazy(() =>
  import('./clusters/downtime/pages/downtime-queue/components/PageDowntimeQueue').then(m => ({
    default: m.PageDowntimeQueue
  }))
)
const PageDetailParameterEM = lazy(() =>
  import('./clusters/power/pages/energy-monitoring/components/PageDetailParameterEM').then(m => ({
    default: m.PageDetailParameterEM
  }))
)
const PageDetailPowerMeterEM = lazy(() =>
  import('./clusters/power/pages/energy-monitoring/components/PageDetailPowerMeterEM').then(m => ({
    default: m.PageDetailPowerMeterEM
  }))
)
const PageEnergyMonitoring = lazy(() =>
  import('./clusters/power/pages/energy-monitoring/components/PageEnergyMonitoring').then(m => ({
    default: m.PageEnergyMonitoring
  }))
)
const PageEnergyProduction = lazy(
  () => import('./clusters/power/pages/energy-monitoring/components/PageEnergyProduction')
)
const PageInflux = lazy(() => import('./clusters/md-core/pages/influx/components/PageInflux'))
const ManageJobFunctionEditPage = lazy(
  () => import('./clusters/manage-departement/pages/job-function/components/ManageJobFunctionEditPage')
)
const ManageJobFunctionDetailPage = lazy(
  () => import('./clusters/manage-departement/pages/job-function/components/ManageJobFunctionDetailPage')
)
const ManageJobFunctionAddPage = lazy(
  () => import('./clusters/manage-departement/pages/job-function/components/ManageJobFunctionAddPage')
)
const ManageJobFunctionPage = lazy(
  () => import('./clusters/manage-departement/pages/job-function/components/ManageJobFunctionPage')
)
const PageEditManageJobLevel = lazy(
  () => import('./clusters/manage-departement/pages/job-level/components/PageEditManageJobLevel')
)
const PageDetailManageJobLevel = lazy(
  () => import('./clusters/manage-departement/pages/job-level/components/PageDetailManageJobLevel')
)
const PageAddManageJobLevel = lazy(
  () => import('./clusters/manage-departement/pages/job-level/components/PageAddManageJobLevel')
)
const PageManageJobLevel = lazy(
  () => import('./clusters/manage-departement/pages/job-level/components/PageManageJobLevel')
)
const PageDetailJobList = lazy(() =>
  import('./clusters/job-list/pages/job-list/components/PageDetailJobList').then(m => ({
    default: m.PageDetailJobList
  }))
)
const PageJobList = lazy(() =>
  import('./clusters/job-list/pages/job-list/components/PageJobList').then(m => ({ default: m.PageJobList }))
)
const PageLaserCutting = lazy(() =>
  import('./clusters/laser-cutting/pages/laser-cutting/components/PageLaserCutting').then(m => ({
    default: m.PageLaserCutting
  }))
)
const PageAddManageDowntime = lazy(() =>
  import('./clusters/downtime/pages/manage-downtime/components/PageAddManageDowntime').then(m => ({
    default: m.PageAddManageDowntime
  }))
)
const PageManageDowntime = lazy(() =>
  import('./clusters/downtime/pages/manage-downtime/components/PageManageDowntime').then(m => ({
    default: m.PageManageDowntime
  }))
)
const PageAddMaterial = lazy(() =>
  import('./clusters/material-definition/pages/material/components/PageAddMaterial').then(m => ({
    default: m.PageAddMaterial
  }))
)
const PageMaterial = lazy(() =>
  import('./clusters/material-definition/pages/material/components/PageMaterial').then(m => ({
    default: m.PageMaterial
  }))
)
const PageMaterialType = lazy(() =>
  import('./clusters/material-definition/pages/material-type/components/PageMaterialType').then(m => ({
    default: m.PageMaterialType
  }))
)
const ModulePage = lazy(() => import('./clusters/manage-module/pages/module/components/ModulePage'))
const EditSubPagePage = lazy(() => import('./clusters/manage-module-v2/pages/manage-module/features/edit-page'))
const CreatePagePage = lazy(() => import('./clusters/manage-module-v2/pages/manage-module/features/create-page'))
const EditGeneralPagePage = lazy(
  () => import('./clusters/manage-module-v2/pages/manage-module/features/edit-general-page')
)
const CreateGeneralPagePage = lazy(
  () => import('./clusters/manage-module-v2/pages/manage-module/features/create-general-page')
)
const ModuleListPage = lazy(() => import('./clusters/manage-module-v2/pages/manage-module/features/module-list'))
const EditModulePage = lazy(() => import('./clusters/manage-module-v2/pages/manage-module/features/edit-module'))
const CreateModulePage = lazy(() => import('./clusters/manage-module-v2/pages/manage-module/features/create-module'))
const EditSubPagePage2 = lazy(() => import('./clusters/manage-module-v2/pages/manage-module/features/edit-sub-page'))
const CreateSubPagePage = lazy(() => import('./clusters/manage-module-v2/pages/manage-module/features/create-sub-page'))
const NotificationsPage = lazy(() =>
  import('@/components/templates/notifications/components/NotificationsPage').then(m => ({
    default: m.NotificationsPage
  }))
)
const PageOee = lazy(() => import('./clusters/oee/pages/oee/components/PageOee').then(m => ({ default: m.PageOee })))
const PageOtProtocol = lazy(() => import('./clusters/md-core/pages/ot-protocol/components/PageOtProtocol'))
const ManagePersonnelQualificationPage = lazy(() =>
  import('./clusters/md-production/pages/personnel-qualification/components/ManagePersonnelQualificationPage').then(
    m => ({ default: m.ManagePersonnelQualificationPage })
  )
)
const PageProductConfiguration = lazy(
  () => import('./clusters/product-configuration/pages/product-configuration/components/PageProductConfiguration')
)
const PageProductionRecord = lazy(
  () => import('./clusters/production-record/pages/production-record/components/PageProductionRecord')
)
const ManageQueryGraphicEditPage = lazy(() =>
  import('./clusters/md-core/pages/query-graphic/components/ManageQueryGraphicEditPage').then(m => ({
    default: m.ManageQueryGraphicEditPage
  }))
)
const ManageQueryGraphicDetailPage = lazy(() =>
  import('./clusters/md-core/pages/query-graphic/components/ManageQueryGraphicDetailPage').then(m => ({
    default: m.ManageQueryGraphicDetailPage
  }))
)
const ManageQueryGraphicAddPage = lazy(() =>
  import('./clusters/md-core/pages/query-graphic/components/ManageQueryGraphicAddPage').then(m => ({
    default: m.ManageQueryGraphicAddPage
  }))
)
const ManageQueryGraphicPage = lazy(() =>
  import('./clusters/md-core/pages/query-graphic/components/ManageQueryGraphicPage').then(m => ({
    default: m.ManageQueryGraphicPage
  }))
)
const PageRepetitiveDowntime = lazy(() =>
  import('./clusters/downtime/pages/repetitive-downtime/components/PageRepetitiveDowntime').then(m => ({
    default: m.PageRepetitiveDowntime
  }))
)
const ManageRoleDetailPage = lazy(
  () => import('./clusters/manage-departement/pages/role/components/ManageRoleDetailPage')
)
const ManageRolePage = lazy(() => import('./clusters/manage-departement/pages/role/components/ManageRolePage'))
const PageDetailShift = lazy(() =>
  import('./clusters/md-shift/pages/shift/components/PageDetailShift').then(m => ({ default: m.PageDetailShift }))
)
const PageShift = lazy(() =>
  import('./clusters/md-shift/pages/shift/components/PageShift').then(m => ({ default: m.PageShift }))
)
const PageShiftPlanning = lazy(() =>
  import('./clusters/shift-planning/pages/shift-planning/components/PageShiftPlanning').then(m => ({
    default: m.PageShiftPlanning
  }))
)
const PageSPC = lazy(() => import('./clusters/spc/pages/spc/components/PageSPC').then(m => ({ default: m.PageSPC })))
const ManageStationClusterPage = lazy(() =>
  import('./clusters/work-station/pages/station-cluster/components/ManageStationClusterPage').then(m => ({
    default: m.ManageStationClusterPage
  }))
)
const PageUnitOfMeasurement = lazy(() =>
  import('./clusters/md-unit-of-measurement/pages/unit-of-measurement/components/PageUnitOfMeasurement').then(m => ({
    default: m.PageUnitOfMeasurement
  }))
)
const PageWelding = lazy(() =>
  import('./clusters/welding/pages/welding/components/PageWelding').then(m => ({ default: m.PageWelding }))
)
const PageDetailWorkCenter = lazy(() =>
  import('./clusters/work-station/pages/work-center/components/PageDetailWorkCenter').then(m => ({
    default: m.PageDetailWorkCenter
  }))
)
const PageCreateWorkCenter = lazy(() =>
  import('./clusters/work-station/pages/work-center/components/PageCreateWorkCenter').then(m => ({
    default: m.PageCreateWorkCenter
  }))
)
const PageEditWorkCenter = lazy(() =>
  import('./clusters/work-station/pages/work-center/components/PageEditWorkCenter').then(m => ({
    default: m.PageEditWorkCenter
  }))
)
const PageWorkCenter = lazy(() =>
  import('./clusters/work-station/pages/work-center/components/PageWorkCenter').then(m => ({
    default: m.PageWorkCenter
  }))
)
const PageWorkCenterEntity = lazy(
  () => import('./clusters/work-station/pages/work-center-entity/components/PageWorkCenterEntity')
)
const PageFormWorkflowSimulation = lazy(
  () => import('./clusters/workflow-simulation/pages/manager/features/form-workflow-simulation')
)
const PageDetailWorkflowSimulation = lazy(
  () => import('./clusters/workflow-simulation/pages/manager/features/detail-workflow-simulation')
)
const PageListWorkflowSimulation = lazy(
  () => import('./clusters/workflow-simulation/pages/manager/features/list-workflow-simulation')
)
const PageFormBuilderPlayground = lazy(
  () => import('./clusters/form-builder-manager/pages/manager/features/playground')
)

const coreRoutes = [
  {
    path: 'user',
    children: [
      {
        index: true,
        element: <ManageUserPage />
      },
      {
        path: 'add',
        element: <ManageUserAddPage />
      },
      {
        path: ':id',
        element: <ManageUserDetailPage />
      }
    ]
  },
  {
    path: 'workflow-manager',
    children: [
      {
        index: true,
        element: <WorkflowListPage />
      },
      {
        path: ':workflowId/:workflowVersionId/edit',
        element: <EditWorkflowPage />
      },
      {
        path: ':workflowId/:workflowVersionId/actors/create',
        element: <CreateActorPage />
      },
      {
        path: ':workflowId/:workflowVersionId/actors/:actorVersionId/edit',
        element: <EditActorPage />
      }
    ]
  },
  {
    path: 'workflow-studio',
    children: [
      {
        index: true,
        element: <WorkflowStudioListPage />
      },
      {
        path: ':workflowId/edit',
        element: <EditWorkflowStudioPage />
      },
      {
        path: ':workflowId/actors/create',
        element: <CreateActorStudioPage />
      },
      {
        path: ':workflowId/actors/:actorId/edit',
        element: <EditActorStudioPage />
      }
    ]
  },
  {
    path: 'ws-ticket-simulation',
    children: [
      {
        index: true,
        element: <WorkflowStudioTicketSimulationListPage />
      },
      {
        path: 'create',
        element: <PageTicketSimulationCreateUpdate />
      },
      {
        path: 'edit/:ticketId',
        element: <PageTicketSimulationCreateUpdate mode='update' />
      },
      {
        path: 'detail/:ticketId',
        element: <WorkflowStudioTicketSimulationDetailPage />
      }
    ]
  },
  {
    path: 'ws-work-order-simulation',
    children: [
      {
        index: true,
        element: <WorkflowStudioWorkOrderSimulationListPage />
      },
      {
        path: 'create',
        element: <WorkflowStudioWorkOrderSimulationCreateEditPage type='create' />
      },
      {
        path: 'edit/:workOrderId',
        element: <WorkflowStudioWorkOrderSimulationCreateEditPage type='edit' />
      },
      {
        path: 'detail/:workOrderId',
        element: <WorkflowStudioWorkOrderSimulationDetailPage />
      }
    ]
  },
  {
    path: 'ws-issue-simulation',
    children: [
      {
        index: true,
        element: <WorkflowStudioIssueSimulationListPage />
      },
      {
        path: 'detail/:issueId',
        element: <WorkflowStudioIssueSimulationDetailPage />
      }
    ]
  },
  {
    path: 'form-builder-manager',
    children: [
      {
        index: true,
        element: <FormBuilderManagerListPage />
      },
      {
        path: ':id',
        element: <FormBuilderManagerConfigurationPage />
      },
      {
        path: 'playground/:code',
        element: <PageFormBuilderPlayground />
      }
    ]
  },
  {
    path: 'fb-user-simulation',
    children: [
      {
        index: true,
        element: <FormBuilderManagerSimulationUserPage />
      }
    ]
  },
  {
    path: 'alarm',
    element: <PageAlarmLog />
  },
  {
    path: 'company',
    children: [
      {
        path: ':id/edit',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageAddCompany title='Edit Company' />
          </AclGuard>
        )
      },
      {
        path: ':id',
        element: <PageAddCompany title='Detail Company' />
      },
      {
        path: 'add',
        element: <PageAddCompany />
      },
      {
        index: true,
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageCompany />
          </AclGuard>
        )
      }
    ]
  },
  {
    path: 'component',
    children: [
      {
        path: ':id',
        element: <PageDetailComponent />
      },
      {
        path: 'add',
        element: <PageAddComponent />
      },
      {
        index: true,
        element: <PageComponent />
      }
    ]
  },
  {
    path: 'component-levelling',
    element: <PageComponentLevelling />
  },
  {
    path: 'compressor',
    children: [
      {
        path: 'detail-compressor',
        element: <PageDetailCompressor />
      },
      {
        index: true,
        element: <PageCompressor />
      }
    ]
  },
  {
    path: 'condition-based-monitoring',
    children: [
      {
        path: 'detail-parameter',
        element: <PageDetailParameterCBM />
      },
      {
        index: true,
        element: <PageConditionBasedMonitoring />
      }
    ]
  },
  {
    path: 'dashboard',
    children: [
      {
        path: ':slug',
        element: <PageDashboardInsight />
      }
    ]
  },
  {
    path: 'dashboard-configuration',
    element: (
      <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
        <PageDashboardConfiguration />
      </AclGuard>
    )
  },
  {
    path: 'dashboard-insight',
    children: [
      {
        path: ':slug',
        element: <PageDashboardInsight />
      }
    ]
  },
  {
    path: 'dashboard-manager',
    children: [
      {
        path: ':id',
        element: <PageDashboardConfig />
      },
      {
        index: true,
        element: <PageListtDasboard />
      }
    ]
  },
  {
    path: 'defect',
    children: [
      {
        path: 'add',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageAddDefect />
          </AclGuard>
        )
      },
      {
        index: true,
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageDefect />
          </AclGuard>
        )
      }
    ]
  },
  {
    path: 'department',
    children: [
      {
        path: ':id/edit',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <ManageDepartmentEditPage />
          </AclGuard>
        )
      },
      {
        path: ':id',
        element: <ManageDepartmentDetailPage />
      },
      {
        path: 'add',
        element: <ManageDepartmentAddPage />
      },
      {
        index: true,
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <ManageDepartmentPage />
          </AclGuard>
        )
      }
    ]
  },
  {
    path: 'downtime-queue',
    element: <PageDowntimeQueue />
  },
  {
    path: 'energy-monitoring',
    children: [
      {
        path: 'detail-parameter',
        element: <PageDetailParameterEM />
      },
      {
        path: 'detail-powermeter',
        element: <PageDetailPowerMeterEM />
      },
      {
        index: true,
        element: <PageEnergyMonitoring />
      }
    ]
  },
  {
    path: 'energy-production',
    element: <PageEnergyProduction />
  },
  {
    path: 'influx',
    element: <PageInflux />
  },
  {
    path: 'job-function',
    children: [
      {
        path: ':id/edit',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <ManageJobFunctionEditPage />
          </AclGuard>
        )
      },
      {
        path: ':id',
        element: <ManageJobFunctionDetailPage />
      },
      {
        path: 'add',
        element: <ManageJobFunctionAddPage />
      },
      {
        index: true,
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <ManageJobFunctionPage />
          </AclGuard>
        )
      }
    ]
  },
  {
    path: 'job-level',
    children: [
      {
        path: ':id/edit',
        element: <PageEditManageJobLevel />
      },
      {
        path: ':id',
        element: <PageDetailManageJobLevel />
      },
      {
        path: 'add',
        element: <PageAddManageJobLevel />
      },
      {
        index: true,
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageManageJobLevel />
          </AclGuard>
        )
      }
    ]
  },
  {
    path: 'job-list',
    children: [
      {
        path: 'detail/:id',
        element: <PageDetailJobList />
      },
      {
        index: true,
        element: <PageJobList />
      }
    ]
  },
  {
    path: 'laser-cutting',
    element: <PageLaserCutting />
  },
  {
    path: 'manage-downtime',
    children: [
      {
        path: 'add',
        element: <PageAddManageDowntime />
      },
      {
        index: true,
        element: <PageManageDowntime />
      }
    ]
  },
  {
    path: 'material',
    children: [
      {
        path: 'add',
        element: <PageAddMaterial />
      },
      {
        index: true,
        element: <PageMaterial />
      }
    ]
  },
  {
    path: 'material-type',
    element: <PageMaterialType />
  },
  {
    path: 'module',
    element: (
      <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
        <ModulePage />
      </AclGuard>
    )
  },
  {
    path: 'module-v2',
    children: [
      {
        path: 'clusters/:clusterId/pages/:pageId/edit',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <EditSubPagePage />
          </AclGuard>
        )
      },
      {
        path: 'clusters/:clusterId/pages/create',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <CreatePagePage />
          </AclGuard>
        )
      },
      {
        path: 'general-pages/:pageId/edit',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <EditGeneralPagePage />
          </AclGuard>
        )
      },
      {
        path: 'general-pages/create',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <CreateGeneralPagePage />
          </AclGuard>
        )
      },
      {
        index: true,
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <ModuleListPage />
          </AclGuard>
        )
      },
      {
        path: 'modules/:moduleId/edit',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <EditModulePage />
          </AclGuard>
        )
      },
      {
        path: 'modules/create',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <CreateModulePage />
          </AclGuard>
        )
      },
      {
        path: 'pages/:pageId/edit',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <EditSubPagePage />
          </AclGuard>
        )
      },
      {
        path: 'pages/:pageId/subpages/:subPageId/edit',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <EditSubPagePage2 />
          </AclGuard>
        )
      },
      {
        path: 'pages/:pageId/subpages/create',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <CreateSubPagePage />
          </AclGuard>
        )
      },
      {
        path: 'pages/create',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <CreatePagePage />
          </AclGuard>
        )
      }
    ]
  },
  {
    path: 'notifications',
    element: <NotificationsPage />
  },
  {
    path: 'oee',
    element: <PageOee />
  },
  {
    path: 'ot-protocol',
    element: <PageOtProtocol />
  },
  {
    path: 'personnel-qualification',
    element: <ManagePersonnelQualificationPage />
  },
  {
    path: 'product-configuration',
    element: <PageProductConfiguration />
  },
  {
    path: 'production-record',
    element: (
      <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
        <PageProductionRecord />
      </AclGuard>
    )
  },
  {
    path: 'query-graphic',
    children: [
      {
        path: ':id/edit',
        element: <ManageQueryGraphicEditPage />
      },
      {
        path: ':id',
        element: <ManageQueryGraphicDetailPage />
      },
      {
        path: 'add',
        element: <ManageQueryGraphicAddPage />
      },
      {
        index: true,
        element: <ManageQueryGraphicPage />
      }
    ]
  },
  {
    path: 'repetitive-downtime',
    element: (
      <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
        <PageRepetitiveDowntime />
      </AclGuard>
    )
  },
  {
    path: 'role',
    children: [
      {
        path: ':id',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <ManageRoleDetailPage />
          </AclGuard>
        )
      },
      {
        index: true,
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <ManageRolePage />
          </AclGuard>
        )
      }
    ]
  },
  {
    path: 'shift',
    children: [
      {
        path: ':id',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageDetailShift />
          </AclGuard>
        )
      },
      {
        index: true,
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageShift />
          </AclGuard>
        )
      }
    ]
  },
  {
    path: 'shift-planning',
    element: (
      <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
        <PageShiftPlanning />
      </AclGuard>
    )
  },
  {
    path: 'spc',
    element: <PageSPC />
  },
  {
    path: 'station-cluster',
    element: <ManageStationClusterPage />
  },
  {
    path: 'unit-of-measurement',
    element: <PageUnitOfMeasurement />
  },
  {
    path: 'welding',
    element: <PageWelding />
  },
  {
    path: 'work-center',
    children: [
      {
        path: ':id',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageDetailWorkCenter />
          </AclGuard>
        )
      },
      {
        path: 'add',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageCreateWorkCenter />
          </AclGuard>
        )
      },
      {
        path: 'edit/:id',
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageEditWorkCenter />
          </AclGuard>
        )
      },
      {
        index: true,
        element: (
          <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
            <PageWorkCenter />
          </AclGuard>
        )
      }
    ]
  },
  {
    path: 'workcenter-entity',
    element: (
      <AclGuard guestGuard={false} aclAbilities={{ action: 'read', subject: 'all' }}>
        <PageWorkCenterEntity />
      </AclGuard>
    )
  },
  {
    path: 'workflow-simulation',
    children: [
      {
        path: 'create',
        element: <PageFormWorkflowSimulation pageType='ADD' />
      },
      {
        path: 'detail/:id',
        element: <PageDetailWorkflowSimulation />
      },
      {
        path: 'edit/:id',
        element: <PageFormWorkflowSimulation pageType='EDIT' />
      },
      {
        index: true,
        element: <PageListWorkflowSimulation />
      }
    ]
  }
]

export default coreRoutes
